module.exports = __webpack_public_path__ + "img/cw.7dbea206.svg";